import { useEffect, useState } from "react";

let cache = null;
let inflight = null;
const listeners = new Set();

export function fetchShipping(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-info`, { cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        cache = { fee: Number(d.merch_shipping_fee ?? 0), freeOver: Number(d.merch_free_shipping_threshold ?? 0) };
        listeners.forEach((fn) => fn(cache));
        return cache;
      })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export const shippingLine = (s) => (!s ? "" : s.fee > 0 ? `+ $${s.fee.toFixed(2)} shipping${s.freeOver > 0 ? ` · free over $${s.freeOver.toFixed(0)}` : ""}` : "Free shipping");

export default function useShipping() {
  const [ship, setShip] = useState(cache);
  useEffect(() => {
    listeners.add(setShip);
    fetchShipping().then(setShip).catch(() => {});
    return () => listeners.delete(setShip);
  }, []);
  return ship;
}
